const dbModels = require('../database/models')
const to = require('await-to-js').default
const db = require("../database/database")

async function getUserFromDB(userToken, userAccountId) {
    //const query = dbModels.userQuerySchema(userId)
    //console.log(query)
    const documentPath = 'users/' + userAccountId.toString()
  console.log(documentPath)
  let dbErr, dbRes;
    [dbErr, dbRes] = await to(db.getDocumentByPath(userToken, documentPath))
    if (dbErr) {
      console.error("error getting user from DB", dbErr)
      throw err
    } else if (dbRes) {
      console.log("User pulled to DB!", dbRes)
      return dbRes
    }
}

async function getUserFromDBbyAccountId(userToken,userAccountId) {
    const query = dbModels.userbyAccountIdQuerySchema(userAccountId)
    //const documentPath = "users/" + userAccountId + "/policies?documentId=" + policyId

    console.log(query)
    let dbErr, dbRes;
    [dbErr, dbRes] = await to(db.getDocument("users", query))
    if (dbErr) {
      console.error("error getting user from DB", dbErr)
      throw err
    } else if (dbRes) {
      console.log("User pulled to DB!", dbRes)
      return dbRes
    }
}

  async function getAccidentFromDB(userToken,userAccountId, accidentId){
    //const query = dbModels.accidentQuerySchema(accidentId.toString())
    const documentPath = "users/" + userAccountId.toString() + "/accidents/" + accidentId.toString()
let dbErr, dbRes;
[dbErr, dbRes] = await to(db.getDocumentByPath(userToken,documentPath))
 if (dbErr){
  console.error("error getting user from DB",dbErr)
  throw err
}
else if(dbRes){
  console.log("User pulled to DB!", dbRes)
  return dbRes
}


}

 async function getPolicyFromDB(userToken,userAccountId, policyId){
    //const query = dbModels.policyQuerySchema(policyId.toString())
    const documentPath = "users/" + userAccountId.toString() + "/policies/" + policyId.toString()

let dbErr, dbRes;
[dbErr, dbRes] = await to(db.getDocumentByPath(userToken, documentPath))
 if (dbErr){
  console.error("error getting policy from DB",dbErr)
  throw err
}
else if(dbRes){
  console.log("Policy pulled to DB!", dbRes)
  return dbRes
}
}

async function getAccidentsFromDB (userToken,userAccountId ){
   // const query = dbModels.accidentListQuerySchema(userId)
    const documentPath = "users/" + userAccountId.toString() + "/accidents"

let dbErr, dbRes;
[dbErr, dbRes] = await to(db.getDocumentByPath(userToken, documentPath))
 if (dbErr){
  console.error("error getting accident from DB",dbErr)
  throw err
}
else if(dbRes){
  console.log("accident pulled from DB!", dbRes)
  return dbRes
}


}

async function getPoliciesFromDB(userToken,userAccountId){
    //const query = dbModels.policyListQuerySchema(userId)
    const documentPath = "users/" + userAccountId.toString() + "/policies"

let dbErr, dbRes;
[dbErr, dbRes] = await to(db.getDocumentByPath(userToken, documentPath))
 if (dbErr){
  console.error("error getting user from DB",dbErr)
  throw err
}
else if(dbRes){
  console.log("User pulled to DB!", dbRes)
  return dbRes
}
}

async function addUserToDb(userToken, firstName, lastName,phone, email, zipcode, city, state,userName, userId, accountId, creationDate ){
const document = dbModels.addUserDocumentSchema(firstName, lastName,phone, email, zipcode, city, state,userName, userId, accountId, creationDate)
const documentPath = "users?documentId=" + accountId.toString()
let dbErr, dbRes;
      [dbErr, dbRes] = await to(db.createDocument(userToken, documentPath, document))
       if (dbErr){
        console.error(dbErr)
        throw dbErr
    }
    else if(dbRes){
        return dbRes
    }
}

async function addPolicyToDb(userToken,userAccountId, userId, policyId, providerName,policyName,policyNumber, addressOnPolicy, agentName, agentPhone, dateCreated,  formattedArr ){
    const document = dbModels.addPolicyDocumentSchema(userId, policyId,providerName,policyName,policyNumber, addressOnPolicy, agentName, agentPhone, dateCreated,  formattedArr )
    const documentPath = "users/" + userAccountId.toString() + "/policies?documentId=" + policyId.toString()
    let dbErr, dbRes;
          [dbErr, dbRes] = await to(db.createDocument(userToken, documentPath, document))
           if (dbErr){
            console.error(dbErr)
            throw dbErr
        }
        else if(dbRes){
            return dbRes
        }
    }

    async function addAccidentToDb(userToken, userAccountId, accidentTypeSelect, accidentName, timeValue, dateValue, vehicleSpeedValue, accidentLocation,
        makeValue,modelValue, yearValue, additionalInfoTextArea, userId,timeSubmitted, accidentId, dbArrValues ){
        const document = dbModels.addAccidentDocumentSchema(accidentTypeSelect, accidentName, timeValue, dateValue, vehicleSpeedValue, accidentLocation,
            makeValue,modelValue, yearValue, additionalInfoTextArea, userId,timeSubmitted, accidentId, dbArrValues)
            const documentPath = "users/" + userAccountId.toString() + "/accidents?documentId=" + accidentId.toString()
            let dbErr, dbRes;
              [dbErr, dbRes] = await to(db.createDocument(userToken, documentPath, document))
               if (dbErr){
                console.error(dbErr)
                throw dbErr
            }
            else if(dbRes){
                return dbRes
            }
        }

        async function updateAccident(userToken, userAccountId, accidentId, accidentTypeSelect, accidentName, timeValue, dateValue, vehicleSpeedValue, accidentLocation, makeValue, modelValue, yearValue, additionalInfoTextArea, dbArrValues ){
            const document = dbModels.updateAccidentDocumentSchema(accidentTypeSelect, accidentName, timeValue, dateValue, vehicleSpeedValue, accidentLocation, makeValue, modelValue, yearValue, additionalInfoTextArea, dbArrValues) 
                const documentPath = "users/" + userAccountId.toString() + "/accidents/" + accidentId.toString()
                let dbErr, dbRes;
                  [dbErr, dbRes] = await to(db.updateDocument(userToken, documentPath, document))
                   if (dbErr){
                    console.error(dbErr)
                    throw dbErr
                }
                else if(dbRes){
                    return dbRes
                }
            }

            async function updateAccidentFiles(userToken, userAccountId, accidentId, fileList ){
                const document = {
                    "fields": {
                      "filesUploaded":
              {"arrayValue":{ "values": fileList}
                    }},
                  }                    
                  const documentPath = "users/" + userAccountId.toString() + "/accidents/" + accidentId.toString()
                    let dbErr, dbRes;
                      [dbErr, dbRes] = await to(db.updateDocument(userToken, documentPath, document))
                       if (dbErr){
                        console.error(dbErr)
                        throw dbErr
                    }
                    else if(dbRes){
                        return dbRes
                    }
                }
            
        async function updatePolicy(userToken, userAccountId, policyId, providerName, policyName, policyNumber, addressOnPolicy, agentName, agentPhone, formattedArr ){
            const document = dbModels.updatePolicyDocumentSchema( providerName, policyName, policyNumber, addressOnPolicy, agentName, agentPhone, formattedArr ) 
                const documentPath = "users/" + userAccountId.toString() + "/policies/" + policyId.toString()
                let dbErr, dbRes;
                  [dbErr, dbRes] = await to(db.updateDocument(userToken, documentPath, document))
                   if (dbErr){
                    console.error(dbErr)
                    throw dbErr
                }
                else if(dbRes){
                    return dbRes
                }
            }

            
        async function updateUser(userToken, userAccountId, firstName, lastName, phone, email, zipcode, city, state ){
            const document = dbModels.updateUserDocumentSchema(firstName, lastName, phone, email, zipcode, city, state) 
                const documentPath = "users/" + userAccountId.toString()
                let dbErr, dbRes;
                  [dbErr, dbRes] = await to(db.updateDocument(userToken, documentPath, document))
                   if (dbErr){
                    console.error(dbErr)
                    throw dbErr
                }
                else if(dbRes){
                    return dbRes
                }
            }

module.exports = {updateUser, updateAccident, updatePolicy,updateAccidentFiles, getUserFromDB,getUserFromDBbyAccountId, getPoliciesFromDB, getPolicyFromDB, getAccidentFromDB, getAccidentsFromDB, addUserToDb, addPolicyToDb, addAccidentToDb}


// WEBPACK FOOTER //
// ./src/services/database/common.js